var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row grid--gtm-portfolio"},_vm._l((_vm.boxes),function(solution){return _c('SolutionBox',{key:solution.idSolution,attrs:{"slug":_vm.slug,"solution":solution}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }